import useGetApi from 'src/api/useGetApi';

interface ProductVariantDTO {
  id: string;
  productId: string;
  sku: string | null;
  attributes: Record<string, unknown>;
  originId: string | null;
  originSystem: string | null;
  originEntity: string | null;
  originMetadata: Record<string, unknown> | null;
}

interface ListProductVariantsResponse {
  variants: ProductVariantDTO[];
}

export function useProductVariants(productId: string, enabled = true) {
  return useGetApi<ListProductVariantsResponse>({
    endpoint: `inventory-management/products-v2/${productId}/variants`,
    options: {
      enabled: enabled && !!productId,
    },
  });
}
